<template>
	<div class="materialCheck">
		<div class="searchBar">
			<div class="search">
				<div class="label">素材</div>
				<el-input v-model="keyword" placeholder="输入素材ID或名称" />
				<el-button type="primary" @click="search"> 搜索 </el-button>
			</div>
		</div>
		<div v-infinite-scroll="load" class="content" infinite-scroll-disabled="disabled" infinite-scroll-distance="40">
			<material-item
				v-for="item in list"
				:key="item.id"
				class="material-item"
				:class="[`material-item${type}`, { active: item.check }]"
				:item="item"
				@click.native="choose(item)"
			/>
			<p v-if="loading">加载中...</p>
			<p v-if="noMore && list.length">没有更多了</p>
			<div v-if="noMore && !list.length" class="noContent">
				<img src="@/assets/img/materilaNoContent.png" alt="" />
				<div>暂无相关素材</div>
			</div>
		</div>
	</div>
</template>

<script>
import { errors, materialPersonal, materialPersonalDocuments } from '@services';
import materialItem from './materialItem';
export default {
	components: {
		materialItem,
	},
	props: {
		type: {
			type: Number,
			required: true,
		},
		getParams: {
			type: Object,
			required: true,
		},
		useParams: {
			type: Object,
			required: true,
		},
		usePayload: {
			type: Object,
			required: true,
		},
		multiple: {
			type: Boolean,
			required: true,
		},
		maxLen: {
			type: Number,
			required: true,
		},
	},
	data() {
		return {
			keyword: '',
			pageSize: 12,
			pageNum: 1,
			list: [],
			loading: false,
			noMore: false,
			check: 0,
		};
	},
	computed: {
		disabled() {
			return this.loading || this.noMore;
		},
		checkList() {
			return this.list.filter((e) => e.check);
		},
	},
	mounted() {},
	methods: {
		async load() {
			try {
				this.loading = true;
				const { pageSize, pageNum, keyword, type } = this;
				const { ok, data } = await materialPersonal.getList({
					pageSize,
					pageNum,
					keyword,
					type,
					...this.getParams,
				});
				if (ok) {
					let list = data.data.list.map((e) => {
						e.check = false;
						return e;
					});
					this.list = [...this.list, ...list];
					if (this.pageNum >= data.data.pages) {
						this.noMore = true;
					} else {
						this.pageNum++;
					}
				}
				this.loading = false;
			} catch (err) {
				errors(err);
			}
		},
		search() {
			this.noMore = false;
			this.pageNum = 1;
			this.list = [];
			this.load();
		},
		async choose(item) {
			let result = !item.check;
			if (this.multiple) {
				if (this.checkList.length >= this.maxLen && result) {
					this.$message.error(`最多只能选择${this.maxLen}个`);
					return;
				}
			} else {
				if (result) {
					for (let i = 0; i < this.list.length; i++) {
						const e = this.list[i];
						e.check = false;
					}
				}
			}

			item.check = result;
		},
		async use() {
			if (this.checkList.length == 0) {
				this.$message.error('请先选择素材');
			} else {
				let arr = [];
				for (let i = 0; i < this.checkList.length; i++) {
					const item = this.checkList[i];
					try {
						let res;
						// 3为文档
						if (this.type == 3) {
							res = await materialPersonalDocuments.use(item.id, this.usePayload);
						} else {
							res = await materialPersonal.use(item.id, this.useParams, this.usePayload);
						}
						const { ok, data } = res;
						if (ok) {
							arr.push(data.data);
						}
					} catch (err) {
						errors(err);
					}
				}
				if (arr.length > 0) {
					if (this.multiple) {
						return arr;
					} else {
						return arr[0];
					}
				}
			}
		},
	},
};
</script>

<style lang="less">
.materialCheck {
}
</style>
